import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useGlobalStore } from './services/store/store'

const PrivateRoute = () => {
	const loggingOut = useGlobalStore((state) => state.loggingOut)
	const userToken = useGlobalStore((state) => state.userToken)
	if (!userToken && !loggingOut) return <Navigate to="/login" />
	return <Outlet />
}

export default PrivateRoute
